import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
}
export function CTAButton({
  text = '¡QUIERO RECUPERAR MI TIEMPO AHORA!',
  className = '',
  href
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={() => {
    if (href) {
      window.open(href, '_blank');
    } else {
      document.getElementById('oferta')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} className={`
        relative group overflow-hidden rounded-lg font-bold text-lg md:text-xl px-8 py-5
        bg-[#22c55e] hover:bg-[#16a34a] text-white
        shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)]
        transition-all duration-300 flex items-center justify-center gap-3 w-full md:w-auto
        ${className}
      `} data-id="element-171">
      <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-172" />
      <Zap className="w-6 h-6 fill-current" data-id="element-173" />
      <span data-id="element-174">{text}</span>
    </motion.button>;
}